module.exports = __webpack_public_path__ + "img/whatsapp.a62bed13.svg";